export default __webpack_public_path__ + "static/media/bihada-factory-mission-10.f57669a3.jpg";